import React from 'react';
import Icon from '../../../components/AppIcon';

const AdmissionRequirements = ({ requirements }) => {
  return (
    <div className="space-y-4 md:space-y-6">
      <div className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4 md:mb-5 flex items-center gap-2">
          <Icon name="FileCheck" size={24} color="var(--color-primary)" />
          Academic Requirements
        </h3>
        <div className="space-y-3 md:space-y-4">
          {requirements?.academic?.map((req, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center mt-0.5">
                <Icon name="Check" size={14} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground font-caption">
                  {req}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4 md:mb-5 flex items-center gap-2">
          <Icon name="Languages" size={24} color="var(--color-primary)" />
          Language Proficiency
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {requirements?.language?.map((lang, index) => (
            <div key={index} className="flex items-center gap-3 p-3 md:p-4 bg-muted/50 rounded-lg">
              <Icon name="Award" size={20} color="var(--color-accent)" />
              <div>
                <p className="text-sm md:text-base font-medium text-foreground">
                  {lang?.test}
                </p>
                <p className="text-xs md:text-sm text-muted-foreground font-caption">
                  Minimum Score: <span className="font-medium data-text">{lang?.score}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4 md:mb-5 flex items-center gap-2">
          <Icon name="FolderOpen" size={24} color="var(--color-primary)" />
          Required Documents
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {requirements?.documents?.map((doc, index) => (
            <div key={index} className="flex items-start gap-3 p-3 md:p-4 bg-background rounded-lg border border-border">
              <Icon name="FileText" size={18} color="var(--color-primary)" />
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground mb-1">
                  {doc?.name}
                </p>
                <p className="text-xs md:text-sm text-muted-foreground font-caption">
                  {doc?.format}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-start gap-3 md:gap-4">
          <Icon name="Calendar" size={24} color="var(--color-accent)" />
          <div className="flex-1 min-w-0">
            <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
              Application Timeline
            </h4>
            <div className="space-y-2 md:space-y-3">
              {requirements?.timeline?.map((item, index) => (
                <div key={index} className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-sm md:text-base font-medium text-accent data-text whitespace-nowrap">
                    {item?.date}
                  </span>
                  <span className="text-sm md:text-base text-foreground font-caption">
                    {item?.event}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmissionRequirements;